module.exports = __webpack_public_path__ + "img/sv64.296a8fc5.svg";